// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest,deleteRequest } from '@/libs/axios';

// 钱包消费明细分页列表查询
export const _findRecordByPage = (params) => {
    return getRequest('/registerEwallet/findRecordByPage', params)
}
// 用户钱包信息
export const _findOne = (params) => {
    return getRequest('/registerEwallet/findOne', params)
}
//提现
export const _saveMoney = (params) => {
    return postRequest('/vo/save', params)
}
//邀请好友提现
export const _getMoney = (params) => {
    return postRequest('/invite/save', params)
}
//提现明细
export const _getByPage = (params) => {
    return getRequest('/vo/getByPage', params)
}
//邀请好友明细
export const _getInviteByPage = (params) => {
    return getRequest('/invite/getByPage', params)
}
//用户登录记录接口
export const _getLogn = (params) => {
    return getRequest('/registerInoutLog/getByPage', params)
}
// 红包余额
export const _getFindOne = (params) => {
    return getRequest('/registerRedEnvelope/findOne', params)
}
// 红包明细
export const _getRedEnvelope = (params) => {
    return getRequest('/registerRedEnvelope/findRecordByPage', params)
}
// 钱包充值接口
export const _getrecharge = (params) => {
    return postRequest('/registerEwallet/recharge', params)
}
// 校验核验码
export const _getVerifyCode = (params) => {
    return getRequest('/verifyOperation/verifyCode', params)
}
//获取公示信息接口
export const _getVerifyInfo = (params) => {
    return getRequest('/disclosure/get', params)
}
//核验证书编码
export const _getByEvidenceArchiveCertNumber = (params) => {
    return getRequest('/disclosure/getByEvidenceArchiveCertNumber', params)
}
//成就详情
export const _getValidByPage = (params) => {
    return getRequest('/registerInviteCommission/getValidByPage', params)
}
//新增转账到钱包申请
export const _drawMoney = (params) => {
    return postRequest('/registerInviteCommission/drawMoney', params)
}
//个人中心输入邀请码
export const _inputInviteCode = (params) => {
    return getRequest('/registerInviteCode/inputInviteCode', params)
}
//可开票金额接口
export const _getAmountTotal = (params) => {
    return getRequest('/paymentBusiness/getAmountTotal', params)
}
//发票记录列表接口
export const _getFindPage = (params) => {
    return getRequest('/registerReceipt/getByPage', params)
}
//申请发票列表接口
export const _getAvailable = (params) => {
    return getRequest('/paymentBusiness/findPage', params)
}
//发票申请接口
export const _saveBill = (params) => {
    return postRequest('/registerReceipt/save', params)
}

//重开发票
export const _afreshReceipt = (params) => {
    return postRequest('/registerReceipt/afreshReceipt', params)
}
// 优惠卷
export const couponList = (params) => {
    return getRequest('/discountCouponSnapshot/getMyDiscountCoupon', params)
}
// 订单优惠卷
export const orderCouponList = (params) => {
    return getRequest('/discountCouponSnapshot/queryAvailableCoupon', params)
}
//支付订单提交
export const payOrderSubmit = (params) => {
    return postRequest('/registerVipMemberApplication/submitOrder', params)
}
//会员开通 订单支付
export const _orderPay = (params) => {
    return postRequest('/registerVipMemberApplication/orderPayment', params)
}
//订单支付详情
export const getOrderDetail = (id,params) => {
    return getRequest(`/registerVipMemberApplication/getByOrderSeqNo/${id}`, params)
}
//取消订单
export const _cancelOrder = (id,params) => {
    return getRequest(`/registerVipMemberApplication/cancelOrder/${id}`, params)
}
//删除订单
export const _deleteOrder = (id,params) => {
    return getRequest(`/registerVipMemberApplication/deleteOrder/${id}`, params)
}
//获取未支付数量
export const _countOrder = (params) => {
    return getRequest(`/registerVipMemberApplication/countOrder`, params)
}

//前海版权公共服务平台删除订单
export const _deleteOrderByIds = (id,params) => {
    return deleteRequest(`/paymentBusiness/delByIds/${id}`, params)
}
